/*
 * Copyright (c) 2023. Haodong JU
 */

import GlobalSettings from '@/model/global/GlobalSettings'

import hillo from 'hillo'
import Section from '@/model/dataLayer/api/tableAndPerson/Section'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import { updateCloudReservableTable } from '@/model/dataLayer/api/newReservation/reservationTable'
// import store from '../store'

const entity = {
  // images: {
  //   type: IKDataEntity.Types.Images,
  //   formConfig: {
  //     required: false,
  //     hint: 'standard_size_512x512' // 尺寸最好为512*512
  //   }
  // },
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    form: false,
    header: false
  },
  imagesDisplay: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  name: {
    displayName: 'RoomName'
  },
  descriptionZH: {
    formConfig: {
      required: false
    },
    header: false
  },
  descriptionEN: {
    formConfig: {
      required: false
    },
    header: false
  },
  descriptionDE: {
    formConfig: {
      required: false
    },
    header: false
  },
  recommendCount: {
    formConfig: {
      required: false
    },
    header: false
  },
  tableType: {
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          return tableType
        },
        itemText: 'label',
        itemValue: 'value'
      }
    },
    form: false,
    header: false
  },
  pricePer15Min: {
    header: false,
    formConfig: {
      default: 0,
      required: false
    }
  },
  minConsumePrice: {
    header: false,
    formConfig: {
      default: 0,
      required: false
    }
  },
  sectionId: {
    displayName: 'sectionName',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: Section.getList,
        itemText: 'name'
      }
    },
    form: false,
    header: false
  },
  seatCount: {
    formConfig: {
      hint: 'the_max_number_of_reserved_customer_at_this_table', // 在本桌接受预定时,最多可以容纳多少个人
      default: 4
    }
  }
}
const config = {
  add: function (item) {
    item.tableType = 'Room'
    return hillo.postWithUploadFile('Tables.php?op=add', item, {
      showLoading: true
    })
  },
  edit: async function (item) {
    item.description = item.descriptionZH + '|' + item.descriptionEN + '|' + item.descriptionDE + '|' + item.recommendCount
    const res = await hillo.postWithUploadFile('Tables.php?op=update', item)
    await updateCloudReservableTable()
    return res
  },
  remove: function (id) {
    return hillo.post('Tables.php?op=delete', { id })
  },
  load: async function (filter) {
    return (await hillo.get('Tables.php', {
      op: 'currentInfos',
      lang: GlobalSettings.getLang(),
      ...filter
    })).content.filter(it => parseInt(it.sectionId) !== 6).filter(it => it.tableType === 'Room').map(it => {
      // it.descriptionZH = it.description.split('|')[0]
      // it.descriptionEN = it.description.split('|')[1]
      // it.descriptionDE = it.description.split('|')[2]
      // it.recommendCount = it.description.split('|')[3]
      [it.descriptionZH, it.descriptionEN, it.descriptionDE, it.recommendCount] = it.description.split('|')
      return it
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)

export const getAllTableList = async function () {
  return (await hillo.get('Tables.php', {
    op: 'currentInfos'
  })).content
}

export const tableType = [
  {
    label: 'Table',
    value: 'Table'
  },
  {
    label: 'Room',
    value: 'Room'
  }
]
